import type { JSX } from 'preact';

/** Minimal inline icons so the bundle pulls in no icon dependency. */

export function ChatIcon(): JSX.Element {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M4 5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H9l-4 4v-4H6a2 2 0 0 1-2-2V5Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function CloseIcon(): JSX.Element {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M6 6l12 12M18 6 6 18"
        stroke="currentColor"
        stroke-width="2.2"
        stroke-linecap="round"
      />
    </svg>
  );
}

export function SendIcon(): JSX.Element {
  // Mirrored for RTL so the arrow points toward the start (right).
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" style="transform: scaleX(-1)">
      <path d="M4 12 20 4l-3 16-5-5-5 1Z" fill="currentColor" />
    </svg>
  );
}

export function ThinkingIcon(): JSX.Element {
  // An open book — shown gently pulsing while the bookseller is thinking.
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M12 6.5C10.1 5.2 7.8 4.6 5.5 4.6V17c2.3 0 4.6.6 6.5 1.9 1.9-1.3 4.2-1.9 6.5-1.9V4.6c-2.3 0-4.6.6-6.5 1.9Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linejoin="round"
      />
      <path d="M12 6.5v12.4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
    </svg>
  );
}
